<template>
    <div class="bars-spinner" :style="spinnerStyle">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
    </div>
</template>

<script>
    export default {
        name: "Loader",
        props: {
            spinnerStyle: {
                type: Object,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .bars-spinner,
    .bars-spinner * {
        box-sizing: border-box;
    }

    .bars-spinner {
        height: 15px;
        width: calc(68px * 3);
        text-align: center;
        margin: auto;
    }

    .bars-spinner .bar {
        width: 50px;
        height: 200px;
        margin: 0 calc(15px / 2);
        border: calc(15px / 5) solid transparent;
        float: left;
        transform: scale(0);
        animation: bars-spinner-animation 3000ms cubic-bezier(0, 1.95, 0.9, 0.89) infinite 0ms;
    }

    .bars-spinner .bar:nth-child(1) {
        animation-delay: calc(300ms * 1);
        background: #008ad8;
    }

    .bars-spinner .bar:nth-child(2) {
        animation-delay: calc(300ms * 2);
        background: #1b4bb9;
    }

    .bars-spinner .bar:nth-child(3) {
        animation-delay: calc(300ms * 3);
        background: #092854;
    }

    @keyframes bars-spinner-animation {
        50% {
            transform: scale(1);
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
</style>
